import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {JobsDataService} from "../../../modules/jobs/jobs-data.service";
import {ActivatedRoute, Router} from "@angular/router";


@Component({
    selector: 'app-favorite-jobs',
    templateUrl: './favorite-jobs.component.html',
    styleUrls: ['./favorite-jobs.component.scss'],
})

export class FavoriteJobsComponent implements OnInit {

    jobs: any = [];

    jobsArray: {
        job?: object;
        }[] = [];

    constructor(private http: HttpClient,
                private jobsService: JobsDataService,
                private router: Router,
                private route: ActivatedRoute) {}

    ngOnInit() {
        this.jobsService.getFavJobs().subscribe(jobs => {
            this.jobs = jobs;

            for (let job of this.jobs) {
                this.jobsService.getCurrentJob(job).subscribe( resJob => {
                    this.jobsArray.push(resJob);
                })
            }

        })
    }

    // Delete job from favorites
    deleteFavJob(jobId) {
        this.jobsService.deleteFavJob(jobId).subscribe(respData => {
            window.location.reload();
        })
    }

}
